function countrySelect(targetId) {

  if (!$(targetId).length) {
    console.log('no ID in dom');
    return;
  }

  var identifier = targetId.slice(1);

  // Create List
  var $ul = $('<ul/>'),
    list = [],
    selectedOption;

  $.each($(targetId).find('option'), function(i, option) {
    var $option = $(option),
      selected = false;
    if ($option.is(':selected')) {
      selectedOption = $option;
      selected = true;
    }
    list.push('<li><a href="javascript:void(0)" class="country-selection-' + identifier + (selected ? ' active' : '') + ' country-selection keypress' + '" data-value="' + $option.val() + '" data-country-name="' + $option.text().toLowerCase() + '"><span class="flag flag-' + $option.val().toLowerCase() + '"></span>' + $option.text() + '</a></li>');
  });

  $ul.append(list.join(''));

  var $countrySelectionListContainer = $('<div class="csl country-selection-list country-selection-list-' + identifier + '" />').append($ul);

  $(targetId).after($countrySelectionListContainer);

  $(targetId).on('mousedown', function(e) {
    e.preventDefault();
    this.blur();
    window.focus();
  });

  $(targetId).parent().on('click', function(e) {
    e.stopPropagation();
    $('.jq-flag-selection-list, .country-selection-list').hide(); // Hide other possible dropdowns
    $countrySelectionListContainer.toggle();
    $('.country-selection-' + identifier).removeClass('active');
    $('.country-selection-' + identifier + '[data-value=' + $(targetId).find('option:selected').val() + ']').trigger('mouseover');
    countrySelectionEnsureVisibility();
  });

  $('.country-selection-' + identifier).on('click', function(e) {
    e.stopPropagation();
    var _this = $(this),
      val = _this.data('value');

    $(targetId).val(val).trigger('change');;
    $(targetId).parent().find('> .flag').attr('class', 'flag flag-' + val.toLowerCase());

    _this.addClass('active');
    $countrySelectionListContainer.hide(1, resetArrLetter());
  });

  $('.country-selection-' + identifier).on('mouseover', function() {
    var _this = $(this);
    $('.country-selection-' + identifier).removeClass('active');
    _this.addClass('active');
  });

  $(targetId).on('change', function() {
    var _this = $(this);
    $('.country-selection-' + identifier + '[data-country-name="' + _this.val() + '"]').trigger('click');
  });

  $(document).on('click', function(e) {
    e.stopPropagation();
    if (e.target.className != ('country-selection-list-' + identifier) || e.target.parentNode.className != ('country-selection-list-' + identifier)) {
      $countrySelectionListContainer.hide(1, resetArrLetter());
    }
  });
}

function resetArrLetter() {
  arrLetter = [];
}

var arrLetter = [],
  lastKeypress = 0,
  allowance = 0,
  lastQueryLetterLen = 0,
  ctr = 0;

// Listen to the keyboard press event to select country based on what the user typed
$(document).on('keypress', function(e) {
  // Only run this block of code when .country-selection-list is visible
  if ($('.country-selection-list').is(':visible')) {

    e = e || window.event; // consider IE

    var code = e.keyCode || e.which; // consider IE
    var $target = $('.country-selection-list').filter(':visible');

    // Reset the array if more than 1 second since the last stroke. So if you first type, "p" and then "h"
    // within 1 second you display "Philippines". But if you type "p", wait 2 seconds and then "h" you first
    // display "Panama" and then "Honduras".

    // Reset the array if there are more than 3 characters already
    if (arrLetter.length == 3 || (+new Date() > +allowance)) {
      arrLetter = [];
    }

    if (+new Date() > +allowance) {
      ctr = 0;
    }

    arrLetter.push(String.fromCharCode(code).toLowerCase());

    $target.find('.country-selection').removeClass('active');
    var $selectedItem = $target.find('.country-selection.keypress[data-country-name^="' + String(arrLetter.join('')) + '"]:eq(' + ctr + ')');

    if ($selectedItem.length) {
      $selectedItem.addClass('active');

      // Make sure to see what is active. Scroll to it
      var selectedItemTop = $selectedItem.offset().top,
        parentTop = $target.offset().top;

      $target.scrollTop($target.scrollTop() + (selectedItemTop - parentTop));
    } else {
      ctr++;

      // If you type "b" and the selected already starts with "b" then you select the next country
      // starting with "b". If there's no more countries after the selected country starting with "b", then you start over.
      lastQueryLetterLen = $target.find('.country-selection.keypress[data-country-name^="' + String(arrLetter[0]) + '"]').length;

      if (ctr > (lastQueryLetterLen - 1)) {
        ctr = 0;
      }

      if (arrLetter.length > 1 && (arrLetter[0] == arrLetter[arrLetter.length - 1].toUpperCase())) {
        $target.find('.country-selection').removeClass('active');
        var $newSelItem = $target.find('.country-selection.keypress[data-country-name^="' + String(arrLetter[0]) + '"]:eq(' + ctr + ')');
        $newSelItem.addClass('active');
        arrLetter.pop(); // Remove the item of the array
      }
    }

    lastKeypress = new Date(),
      allowance = new Date().setTime(lastKeypress.getTime() + 1000);

    countrySelectionEnsureVisibility();
    e.preventDefault();
  }
});

// Listen to the keyboard press event to select country based on up/down arrow
$(document).on('keydown', function(e) {
  // Only run this block of code when .country-selection-list is visible
  if ($('.country-selection-list').is(':visible')) {
    e = e || window.event; // consider IE

    var $target = $('.country-selection-list').filter(':visible'),
      $targetPrev = $target.prev(),
      activeNow = $target.find('.country-selection.active');

    if (e.which == 38 || e.which == 40) { // 38 = up arrow, 40 = down arrow
      if (e.which == 40) {
        if (activeNow.length == 0) {
          $target.find('.country-selection').first().addClass('active');
        } else {
          var next = activeNow.parent().next().find('.country-selection');
          if (next.length > 0) {
            next.addClass('active');
          } else {
            next = activeNow.closest('ul').children('li').first().find('.country-selection');
            next.addClass('active');
          }
        }
      } else {
        if (activeNow.length == 0) {
          $target.find('.country-selection').last().addClass('active');
        } else {
          var prev = activeNow.parent().prev().find('.country-selection');
          if (prev.length > 0) {
            prev.addClass('active');
          } else {
            prev = activeNow.closest('ul').children('li').last().find('.country-selection');
            prev.addClass('active');
          }
        }
      }

      activeNow.removeClass('active');
      countrySelectionEnsureVisibility();
      e.preventDefault();
    }

    if (e.which == 13) { // enter
      activeNow.trigger('click');
    }
  }
});

// Show LandCode active selection
function countrySelectionEnsureVisibility() {
  var $target = $('.country-selection-list').filter(':visible'),
    $li = $target.find('.country-selection.active').parent();

  if ($li.length) {
    var position = $li.position().top;
    var height = $li.innerHeight();

    if (position < 0) {
      $target.scrollTop($target.scrollTop() + position);
    } else if (position + height > $target.innerHeight()) {
      var diff = position + height - $target.innerHeight();
      $target.scrollTop($target.scrollTop() + diff);
    }
  }
}